module.exports = __webpack_public_path__ + "static/media/Tutorial-2.230f0c11.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/tutorial/Tutorial-2.png
// module id = 829
// module chunks = 0